import * as types from '../constants/actionTypes';
// import * as auth from '../../tools/auth0.cred';
import * as api from '../tools/apiConfig';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';


export function getPatientVsAppointments(data) {
	return function (dispatch, getState) {
		axios.post(api.PATIENT_VS_APPOINTMENTS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					if (data) {
						return dispatch({
							type: types.PATIENT_VS_APPOINTMENTS,
							statistics: response.data.data
						})
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					browserHistory.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getRevenueOfCountryMedfix(data) {
	return function (dispatch, getState) {
		axios.post(api.TOTAL_TURNOVER_VS_REVENU, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					if (data) {
						return dispatch({
							type: types.TOTAL_TURNOVER_VS_REVENU,
							TurnOverCountrystatistics: response.data.data
						})
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					browserHistory.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}
export function getRevenueOfCountry(data) {
	return function (dispatch, getState) {
		axios.post(api.TOTAL_TURNOVER_F2F_ON_VS_REVENU, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					if (data) {
						return dispatch({
							type: types.TOTAL_TURNOVER_F2F_ON_VS_REVENU,
							TurnOverF2FONCountrystatistics: response.data.data
						})
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					browserHistory.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}


export function getRateVsPatients(data) {
	return function (dispatch, getState) {
		axios.post(api.RATE_VS_PATIENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({
							type: types.RATE_VS_PATIENT,
							rateStats: response.data.data
						})
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					browserHistory.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}


export function getAppointmentRevenue(data) {
	return function (dispatch, getState) {
		axios.post(api.APPOINTMENT_REVENUE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({
							type: types.APPOINTMENT_REVENUE,
							appRevStats: response.data.data
						})
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					browserHistory.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}


export function getMedfixRevenue(data) {
	return function (dispatch, getState) {
		axios.post(api.MEDFIX_REVENUE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({
							type: types.MEDFIX_REVENUE,
							medfixRevStats: response.data.data
						})
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					browserHistory.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getRevenueByStatusandCountry(data) {

	return function (dispatch, getState) {
		axios.post(api.GET_REVENUE_BY_STATUS_COUNTRY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.GET_REVENUE_BY_STATUS_COUNTRY, getRevenewByStatusCountry: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}

export function getSpecialistForProfileImage(data) {

	return function (dispatch, getState) {
		// dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.GET_SPECIALIST_FOR_IMAGES, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.GET_SPECIALIST_FOR_IMAGES, data: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}
export function updateIsProfileImageVerified(data,tabClicked) {

	return function (dispatch, getState) {
		// dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.UPDATE_PROFILE_IMAGE_VERIFIED, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
          toast.info(response.data.message)
		 if(tabClicked==1){			
		  axios.post(api.GET_SPECIALIST_FOR_IMAGES, data, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								if (data) {
									return dispatch({ type: types.GET_SPECIALIST_FOR_IMAGES, data: response.data.data })
								}
							} else if (response.data.code == 402) {
							}
						})
						.catch(function (error) {
						});
					}else if(tabClicked==2){
						axios.post(api.GET_APPROVED_SPECIALIST_FOR_IMAGES, data, {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + localStorage.token
							}
						})
							.then(function (response) {
								if (response.data.code == 200) {
									if (data) {
										return dispatch({ type: types.GET_APPROVED_SPECIALIST_FOR_IMAGES, data: response.data.data })
									}
								} else if (response.data.code == 402) {
								}
							})
							.catch(function (error) {
							});
					}
					if (data) {
						return dispatch({ type: types.UPDATE_PROFILE_IMAGE_VERIFIED, data: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
			
	}
}


export function getBlogImagesForAdmin(data) {

	return function (dispatch, getState) {
		// dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.GET_BLOGS_FOR_IMAGES, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.GET_BLOGS_FOR_IMAGES, data: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}

export function updateBlogImageVerified(data,tabClicked) {

	return function (dispatch, getState) {
		// dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.UPDATE_BLOGS_IMAGE_VERIFIED, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
        toast.info(response.data.message)

        if (response.data.code == 200) {
			if(tabClicked == 3){
					axios.post(api.GET_BLOGS_FOR_IMAGES, data, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								if (data) {
									return dispatch({ type: types.GET_BLOGS_FOR_IMAGES, data: response.data.data })
								}
							} else if (response.data.code == 402) {
							}
						})
						.catch(function (error) {
						});}
						else if(tabClicked == 4){
							axios.post(api.GET_APPROVED_BLOGS_FOR_IMAGES, data, {
								headers: {
									'Content-Type': 'application/json',
									'Authorization': 'Bearer ' + localStorage.token
								}
							})
								.then(function (response) {
									if (response.data.code == 200) {
										if (data) {
											return dispatch({ type: types.GET_APPROVED_BLOGS_FOR_IMAGES, data: response.data.data })
										}
									} else if (response.data.code == 402) {
									}
								})
								.catch(function (error) {
								});
						}
					if (data) {
						return dispatch({ type: types.UPDATE_PROFILE_IMAGE_VERIFIED, data: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}

export function getSpecialistWithApprovedProfileImage(data) {

	return function (dispatch, getState) {
		// dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.GET_APPROVED_SPECIALIST_FOR_IMAGES, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.GET_APPROVED_SPECIALIST_FOR_IMAGES, data: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}
export function getBlogsWithApprovedImages(data) {

	return function (dispatch, getState) {
		// dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.GET_APPROVED_BLOGS_FOR_IMAGES, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.GET_APPROVED_BLOGS_FOR_IMAGES, data: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}